export default "---\nname: \"The Wolf's Blades\"\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"